import { ROLES } from "../../../const"
import type { ApiRoleStrategy } from "../../../hooks"

const adhConf = {
  queryKey: ["financial-data", "adherent", "sales"],
  endpoint: "/api/financial-data/adherent/sales",
}

export const apiRoleConf = (pharmacyId?: string): ApiRoleStrategy => ({
  [ROLES.ADHERENT_HOLDER]: adhConf,
  [ROLES.ADHERENT_TEAM]: adhConf,
  [ROLES.ADMIN]: {
    queryKey: ["financial-data", "pharmacies", pharmacyId ?? "", "sales"],
    endpoint: `/api/financial-data/pharmacies/${pharmacyId}/sales`,
  },
  [ROLES.ADHERENT_ADVISOR]: {
    queryKey: ["financial-data", "advisor", "pharmacies", pharmacyId ?? "", "sales"],
    endpoint: `/api/financial-data/advisor/pharmacies/${pharmacyId}/sales`,
  },
})
